import amplitude from 'amplitude-js';

import { isDev } from 'utils/Environment';

export const TRACK = {
  // Sections
  SECTIONS: {
    'CONTROL': 'Control',
    'SCHEDULE': 'Schedule',
  },
  // Components
  COMPONENTS: {
    'PLACE': 'Place',
  },
  // User-driven Events
  EVENTS: {
    // Control Section
    SELECT_REGION: 'Select Region',
    SELECT_VIBE: 'Select Vibe',
    GET_TRIP: 'Get Trip',
    GET_TRIP_COMPLETE: 'Get Trip Complete',
    GENERATE_TRIP: 'Generate Trip',
    GENERATE_TRIP_COMPLETE: 'Generate Trip Complete',
    GENERATE_TRIP_FAILED: 'Generate Trip Failed',
    DISMISS_GENERATE_TRIP_ERROR: 'Dismiss Generate Trip Error',
    OPEN_MOBILE_SHARE_DIALOG: 'Open Mobile Share Dialog',
    SELECT_MOBILE_SHARE_DIALOG_OPTION: 'Select Mobile Share Dialog Option',
    // Schedule Section
    SCROLL_TO_DAY: 'Scroll to Day',
    SEE_PREVIOUS_PHOTO: 'See Previous Photo',
    SEE_NEXT_PHOTO: 'See Next Photo',
    FIRST_DAY_DESCRIPTION_NOT_SHOWING: 'First Day Description Not Showing (All Descriptions Likely Filtered Out)',
    SELECT_DAY_TO_SCROLL_TO: 'Select Day to Scroll To',
  },
  // UI-level Events
  ACTIONS: {
    'CLICK': 'Click',
  },
  // Channels
  CHANNEL: {
    'INSTAGRAM': 'Instagram',
    'TIKTOK': 'TikTok',
    'FACEBOOK': 'Facebook',
    'LINKEDIN': 'LinkedIn',
    'COPY': 'Copy',
    'QR': 'QR',
  },
  // Environments
  ENVIRONMENTS: {
    'DEV': 'Dev',
    'PROD': 'Prod',
  },
};

export const recordEvent = async (event, eventContext, extra) => {
  let mergedEventContext;
  const additionalContext = {};

  // Add environment for filtering
  if (isDev) {
    additionalContext.environment = TRACK.ENVIRONMENTS.DEV;
  }

  mergedEventContext = Object.assign({...eventContext}, additionalContext);

  for (let key in mergedEventContext) {
    const value = mergedEventContext[key];
    if ( !(typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') ) {
      delete mergedEventContext[key];
      if ( !(value === null || value === undefined) ) {
        // We consider null and undefined as "valid" values but sending them to Appcues causes a crash.
        // No other types are valid.
        console.warn(`Warning! The property ${key} is invalid in the eventContext argument for recordEvent. It has been deleted to prevent a crash.`);
      }
    }
  }

  // Amplitude tracking
  amplitude.getInstance().logEvent(event, { context: mergedEventContext, ...extra });
};
